import React, { useEffect, useState } from 'react';
import Sidebar from '../Sidebar';
import ReportsList from '../../components/Reports/ReportsList';
import './Reports.css';

const ReportHome = () => {
  // Initialize sidebar state from sessionStorage, default to false (expanded)
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    const savedState = sessionStorage.getItem('isSidebarCollapsed');
    return savedState ? JSON.parse(savedState) : false;
  });

  // Update sessionStorage whenever isSidebarCollapsed changes
  useEffect(() => {
    sessionStorage.setItem('isSidebarCollapsed', JSON.stringify(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  // Toggle sidebar state
  const handleToggleSidebar = () => {
    setIsSidebarCollapsed((prev) => !prev);
  };

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar onToggleSidebar={handleToggleSidebar} isCollapsed={isSidebarCollapsed} />
      <div className={`reports-content-area ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <ReportsList />
      </div>
    </div>
  );
};

export default ReportHome;